type TextLinkProps = {
  hrefLink: string
  displayText: string
  isEmail?: boolean
}

export const TextLink = (props: TextLinkProps) => {
  const { hrefLink, displayText, isEmail } = props

  return (
    <a
      className="text-blue-600 underline"
      href={(isEmail ? 'mailto:' : '') + hrefLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      {displayText}
    </a>
  )
}
